// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_gf-1";
export var quotedThread = "_gf-0";